function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * Controller for the asynchronous "lookup" data loading. It attempts to load the data for the latest request
 * only and ignores all intermediate requests while the current request is in flight.
 *
 * <p>The lookup instance have the following properties and functions:
 * <dl>
 *     <dt>load</dt><dd>Requests to load a data for the specific set of arguments. The arguments would be passed to
 *       the loader directly.</dd>
 *     <dt>state</dt><dd>Current status of the object.</dd>
 * </dl>
 *
 * <p>The state object have the following fields:
 * <dl>
 *     <dt>status</dt><dd>Current status of the lookup. One of 'ready', 'loading', 'error'.</dd>
 *     <dt>value</dt><dd>Lookup result in the 'ready' state. Defaults to <code>defaultValue</code> immediately
 *       after the loader creation and during 'loading' or 'error' states. </dd>
 *     <dt>error</dt><dd>Error definition in the 'error' state, undefined otherwise.</dt>
 * </dl>
 *
 * @param {Function} loader function used to load the data. All the "load" arguments are passed to the loader.
 *   It must return the promise - an operation progress.
 * @param {*} defaultValue value to be exposed on the list during the operation progress.
 * @returns {Object} returns a new Lookup instance.
 */
function createLookup(loader, defaultValue) {
    var nextArgs = void 0;
    var state = {
        'status': 'ready',
        'value': defaultValue
    };

    /** Starts a load operation. */
    function startLoad() {
        state = {
            'status': 'loading',
            'value': defaultValue
        };

        var args = nextArgs;
        nextArgs = undefined;

        var operation = loader.apply(undefined, _toConsumableArray(args));
        operation.then(function (succ) {
            return onLoaded({
                'status': 'ready',
                'value': succ
            });
        }, function (fail) {
            return onLoaded({
                'status': 'error',
                'value': defaultValue,
                'error': fail
            });
        });
    }

    /* Handles a load completion. */
    function onLoaded(newState) {
        if (nextArgs === undefined) {
            /* No pending requests. */
            state = newState;
        } else {
            /* Target changed, have to load a new goal. */
            startLoad();
        }
    }

    /** Handles a change of the loading goal. */
    function onGoalChange() {
        if (state.status === 'loading') {
            return;
        }
        startLoad();
    }

    return {
        get state() {
            return state;
        },
        'load': function load() {
            nextArgs = arguments;
            onGoalChange();
        }
    };
}

export default createLookup;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/quoteandbind/quickquote/pa/util/AsyncLookup.js
// module id = 2194
// module chunks = 0